// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
__webpack_require__.O(undefined, ["js/vendors"], () => (__webpack_require__("./blocks/folder-slider/script.js")))
__webpack_require__.O(undefined, ["js/vendors"], () => (__webpack_require__("./blocks/logos/script.js")))
__webpack_require__.O(undefined, ["js/vendors"], () => (__webpack_require__("./blocks/news-slider/script.js")))
__webpack_require__.O(undefined, ["js/vendors"], () => (__webpack_require__("./blocks/numbers/script.js")))
__webpack_require__.O(undefined, ["js/vendors"], () => (__webpack_require__("./blocks/partners-slider/script.js")))
__webpack_require__.O(undefined, ["js/vendors"], () => (__webpack_require__("./blocks/search/script.js")))
var __webpack_exports__ = __webpack_require__.O(undefined, ["js/vendors"], () => (__webpack_require__("./blocks/team-slider/script.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
